import React, { useEffect, useRef, useState } from "react";
import DropdownPortal from "~/common/components/DropdownPortal/index";

//Assets
import "~/assets/sass/component/dropdown.scss";

const DropdownTemplate = (props) => {
	const [dropdownState, setDropdownState] = useState(false);
	const { children, className, target, vertical } = props;

	let ref = useRef(null);

	function handleClickOutside(e) {
		if (ref.current && !ref.current.contains(e.target)) {
			setDropdownState(false);
		}
	}

	useEffect(() => {
		if (dropdownState) {
			document.addEventListener("click", handleClickOutside, false);
			return () => {
				document.removeEventListener("click", handleClickOutside, true);
			};
		}
	}, [dropdownState]);

	return (
		<div id={`dropdown_${target}`} className="c__dropdown-wrap" ref={ref}>
			<button
				className={`btn-dropdown ${vertical === true ? "vertical" : "horiz"} ${dropdownState ? "visible" : ""}`}
				onClick={() => setDropdownState(!dropdownState)}
			>
				<span />
				<span />
				<span />
			</button>
			<DropdownPortal target={`dropdown_${target}`}>
				<ul
					className={`c__dropdown ${dropdownState ? "visible" : ""} ${className}`}
					onClick={() => setDropdownState(false)}
				>
					{children}
				</ul>
			</DropdownPortal>
		</div>
	);
};

export default DropdownTemplate;
DropdownTemplate.displayName = "DropdownTemplate";

DropdownTemplate.defaultProps = {
	width: 430,
	height: 245,
	className: "",
};

export const DropDownItem = ({ children, className, ...props }) => {
	return (
		<li className={className ? `${className + " c__dropdownItem"}` : "c__dropdownItem"} {...props}>
			{children}
		</li>
	);
};
